import css from 'styled-jsx/css';

export default css`
  .SiteFooter {
    background-color: inherit;
  }
`;
